export default __webpack_public_path__ + "static/media/scooterUnlocked.554a8f5e.svg";